export default __webpack_public_path__ + "static/media/mix-n-match.e8956415.jpg";